export function ToggleElement(HTMLid: string, toggle: boolean) {
	const element = document.getElementById(HTMLid)

	if (toggle) {
		element?.classList.add("visible")
		element?.classList.remove("hidden")
	}
	else {
		element?.classList.remove("visible")
		element?.classList.add("hidden")
	}
}